import * as React from "react";
import { Table} from "antd";
import { connect } from "react-redux";
//import moment from "moment";

interface IDispatchlistProps {
  id:any;
  dispatchlist:any;
}

// 修改
class Dispatchlist extends React.Component<IDispatchlistProps, any> {
  state = {
     list:[]
  };
  constructor(props: IDispatchlistProps) {
    super(props);
  }

  componentDidMount() {
    this.dispatchlist();     
  }

  dispatchlist = () =>{
    const param: any = {
      id: this.props.id
    }; 
    this.props.dispatchlist({
      ...param,
      callback: (data) => {
        this.setState({
           list: data
        });
      }
     });    
  }

  render() {
    const dataSource = this.state.list;
    
    const columns = [{
      title: '接人时间',
      dataIndex: 'date',
      key:'date',
      className:'th',
      width: 300,
    }, {
      title: '车队',
      dataIndex: 'team_name',
      key:'team_name',
      className:'th',

    }, {
      title: "Guide' name",
      dataIndex: 'guide',
      key:'guide',
      className:'th',
    }, {
      title: "Guide' phone",
      dataIndex: 'guide_phone',
      key:'guide_phone',
      className:'th',
    }, {
      title: "Car plate",
      dataIndex: 'plate_number',
      key:'plate_number',
      className:'th',
    }, {
      title: "Driver' phone",
      dataIndex: 'driver_phone',
      key:'driver_phone',
      className:'th',
    }, {
      title: "Driver' name",
      dataIndex: 'driver',
      key:'driver',
      className:'th',
    }, {
      title: "Remark",
      dataIndex: 'remark',
      key:'remark',
      className:'th',
    }, {
      title: "State",
      dataIndex: 'state',
      key:'state',
      className:'th',
    }];

    
    return (
      <React.Fragment>
           <div className="from-email"> 
                   <Table bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSource} columns={columns} />
           </div>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    dispatchlist: dispatch.orderDetails.dispatchlist
  };
};


export default connect(
  mapState ,
  mapDispatch
)(Dispatchlist);
